import { css } from '@emotion/core';
import * as designSystem from '@domain-group/fe-co-allhomes-design-system';
import { globalTokens } from '@domain-group/fe-brary';
export var disclaimerContentContainer = /*#__PURE__*/css("margin:24px 48px 20px 24px;color:", globalTokens.colors.black, ";");
export var disclaimerContentPara = /*#__PURE__*/css(designSystem.typography.bodyLong, " margin:16px 0;");